// extracted by mini-css-extract-plugin
export default {"userActionsMenu":"UserActionsMenu_userActionsMenu__W8+S4","icon":"UserActionsMenu_icon__1l-ik"};